import {TEXTAREA} from '@drivesally/sally-fw/lib/inputTypes';

import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

export default attribute({
  type: TEXTAREA,
  attribute: 'desc',
  label: {
    default: 'Description',
    short: 'Description',
  },
});
